<!--
  ~ Copyright (c) 2023 GM Global Technology Operations LLC. All rights reserved.
  ~ This information is confidential and proprietary to GM Global Technology
  ~ Operations LLC and may not be used, modified, copied or distributed.
  -->
<div class="default-padding">
  <div class="label-container">
    <h4 id="header-text">Select sheet(s):</h4>
  </div>
  <div class="options-container">
    <mat-selection-list [multiple]="isMultiSelect" [(ngModel)]="selectedSheets">
      <mat-list-option *ngFor="let sheet of sheets" [value]="sheet" matTooltip="{{sheet}}" matTooltipPosition="before">
        {{sheet}}
      </mat-list-option>
    </mat-selection-list>
  </div>
</div>

<div class="button-container default-padding">
  <button mat-stroked-button id="cancel-button" class="action-button"
          (click)="onCancel()">
    Cancel
  </button>

  <button mat-raised-button color="primary" id="confirm-button" class="action-button"
          (click)="onConfirm()"
          [disabled]="!selectedSheets || selectedSheets.length === 0">
    Confirm
  </button>
</div>
